import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Col, Row, Container } from "react-bootstrap";
import api from "../../service/api";
import Input from "../../components/Input";
import Button from "../../components/Button";
import Accordion from "../../components/Accordion";
import { 
    SuportButton, 
    SuportText, 
    CardCustom, 
    Title, 
    DivContainer, 
    Close, 
    ModalTitle, 
    ExampleChatTitle, 
    Box,
    Logo100pay,
    Img,
    FaqImg,
    ContainerAccordion
} from "./styles";
import { questions } from "../../data/questions";
import { openModal, closeModal } from "../../helpers/modalFunctions"
import Logo from "../../assets/img/logo.svg";
import FaqImage from "../../assets/img/faq.svg";
import Question from "../../assets/img/question.svg";
import close from "../../assets/icons/close.svg";

const Faq = (): React.ReactElement => {
    const [visibleQuestion, setVisibleQuestion] = useState(100);
    const [searchInput, setSearchInput] = useState("");
    const history = useHistory();
    const login = useSelector((state: {login: any}) => state.login);
    const [arrQuestions, setArrQuestions] = useState<Array<any>>([]);
    const [searchDebounced, setSearchDebounced] = useState("");

    function AccordionGenerator(): JSX.Element[] {
        return arrQuestions.map(question => {
            return(
                <Accordion
                    key={question.id}
                    id={question.id}
                    visibleQuestion={visibleQuestion}
                    setVisibleQuestion={setVisibleQuestion}
                    title={question.title}
                    bodyText={question.bodyText}
                    image={question.image}
                    redirectToTour={question?.link}
                />
            )
        })
    }

    useEffect(() => {
        const timerId = setTimeout(() => {
            setSearchDebounced(searchInput);
        }, 1200);
    
        return () => {
            clearTimeout(timerId);
        }
    }, [searchInput]);

    useEffect(() => {
        if(searchInput !== "") {
            let newQuestions = questions.filter(item => item.bodyText.toLowerCase().includes(searchInput.toLowerCase()))
            
            setArrQuestions(newQuestions) 
        }

        if(searchInput === ""){
            setArrQuestions(questions) 
        }

    }, [searchDebounced])

    const submitFormChat = async (
        values: { chatTitle: string }
    ): Promise<void> => {

        const { data } = await api.post("chat/title/create", {
            branchsId: login.user.branchsId,
            title: values.chatTitle
        });

        closeModal("exampleModal");
        history.push(`/doubts/chat?id=${data.id}`);
    }

    return (
        <Container className="vh-100 d-block">
            <Box 
                className="modal fade" 
                id="exampleModal"  
                aria-labelledby="exampleModalLabel" 
                aria-hidden="true"
            >
                <Box className="modal-dialog modal-dialog-centered">
                    <Box className="modal-content initialize-chat">
                        <Box className="modal-header">
                            <Box className="w-100">
                                <Box className="d-flex justify-content-end">
                                    <Close data-dismiss="modal" aria-label="Close">
                                        <img src={close} alt="fechar"/>
                                    </Close>
                                </Box>
                                <ModalTitle className="modal-title">
                                    Digite em poucas palavras a sua dúvida...
                                </ModalTitle>
                            </Box>
                        </Box>
                        <Box className="modal-body">
                            <Formik
                                initialValues={{
                                    chatTitle: ""
                                }}
                                onSubmit={async (values) => {
                                    await submitFormChat(values)
                                }}
                            >
                                <Form>
                                    <Field id="chatTitle" name="chatTitle" placeholder="digite sua dúvida aqui..." as={Input}/>
                                    <Box className="d-flex justify-content-start">
                                        <ExampleChatTitle>Ex.: Não consigo gerar o boleto</ExampleChatTitle>
                                    </Box>
                                    <Button type="submit">
                                        Ir para o suporte
                                    </Button>
                                </Form>
                            </Formik>
                        </Box>
                        <Box className="modal-footer">
                            
                        </Box>
                    </Box>
                </Box>
            </Box>

            <DivContainer>
                <Row className="d-flex align-items-center justify-content-center">
                    <Col lg="12" className="d-flex align-items-center justify-content-center">
                        <CardCustom>
                            <Container>
                                <Row>
                                    <Col xl="12" className="text-center  py-4">
                                        <Logo100pay src={Logo} />
                                    </Col>

                                    <Row className="d-flex align-items-center justify-content-center">
                                        <Col xs="6" md="3" className="pr-0 d-flex align-items-center justify-content-center order-1 order-md-1">
                                            <FaqImg src={FaqImage}/>
                                        </Col>

                                        <Col xs="12" md="6" className="d-flex align-items-center justify-content-center order-3 order-md-2">
                                            <Title>Olá, como podemos lhe ajudar?</Title>
                                        </Col>

                                        <Col xs="6" md="3" className="d-flex align-items-center justify-content-center order-2 order-md-3">
                                            <SuportButton onClick={() => openModal("exampleModal")}>
                                                <Img src={Question}/>
                                                <SuportText>Fale com o suporte</SuportText>
                                            </SuportButton>
                                        </Col>
                                    </Row>

                                    <Col xl="12" className="mt-3">
                                        <Input 
                                            placeholder="Digite o que você procura" 
                                            style={{height: 33}}
                                            value={searchInput}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setSearchInput(event.target.value)
                                            }}
                                        />
                                    </Col>

                                    <Col xl="12" style={{marginTop: 33}}>
                                        <ContainerAccordion>
                                            { AccordionGenerator() }
                                        </ContainerAccordion>
                                    </Col>
                                </Row>
                            </Container>
                        </CardCustom>
                    </Col>
                </Row>    
            </DivContainer>
        </Container>
    );
};

export default Faq;